import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { subscribe_path } from '@routes';
import { User } from '@utils/backend-api/currentUser';

import Footer from './Footer';
import Header from './Header';
import TimeLine from './TimeLine';

const OFFER_PARAM = 'read-us-first-pro,read-us-first-annual,read-us-first-monthly,read-us-first-yp';
const SUBSCRIBE_PROMO_URL = subscribe_path({ offer: OFFER_PARAM });

const queryClient = new QueryClient();

interface ReadUsFirstProps {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
  isSubscriber: boolean;
}

const ReadUsFirst = ({ env, initialCurrentUser, isWebview, isSubscriber }: ReadUsFirstProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Header isSubscriber={isSubscriber} subscribePromoUrl={SUBSCRIBE_PROMO_URL} />
        <TimeLine />
        <Footer isSubscriber={isSubscriber} subscribePromoUrl={SUBSCRIBE_PROMO_URL} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default ReadUsFirst;
